export default __webpack_public_path__ + "static/media/itau.4ffe0f46.png";